import React from "react";
import { Image, Text, Button } from "@mantine/core";
import { useNavigate } from "react-router-dom";
import { BsArrowDownLeftSquareFill } from "react-icons/bs";

const NotFound = () => {
  // Hooks
  const navigate = useNavigate();

  return (
    <div
      style={{
        minHeight: "90vh",
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
      }}
    >
      <Image
        width={350}
        height={350}
        radius="md"
        src="./assets/illus9.png"
        alt="404"
      />
      <h1 style={{ fontSize: 100 }}>404</h1>
      <Text color="dimmed" style={{ fontSize: 24 }}>
        Oops! Page not found.
      </Text>
      <Text
        color=""
        style={{
          display: "flex",
          alignItems: "center",
          fontSize: 24,
          marginTop: 5,
        }}
      >
        Try the magical button{" "}
        <BsArrowDownLeftSquareFill style={{ marginLeft: 5 }} />
      </Text>
      <Button
        size="lg"
        style={{ marginTop: 20 }}
        variant="gradient"
        gradient={{ from: "indigo", to: "cyan" }}
        onClick={() => navigate("/")}
      >
        Back Home
      </Button>
    </div>
  );
};

export default NotFound;
